// Версии промптов распознавания. Уходят в /ai/gemini-proxy параметром pv и
// пишутся в zoya_recognitions.prompt_version — по ним набор данных для
// дообучения делится на «до правки промпта» и «после».
//
// Правило: меняете текст промпта — поднимайте версию рядом с ним, в тот же
// коммит. Сервер дополнительно хеширует пришедший текст, так что забытая
// версия не смешает ответы, но читать хеши вместо дат неудобно.
export const PHOTO_PROMPT_VERSION      = 'photo-add-2026-10-18'        // AddFoodDialog.DEFAULT_PHOTO_PROMPT
export const ONBOARDING_PROMPT_VERSION = 'photo-onboarding-2026-09-28' // onboarding/StepRecognize.PHOTO_PROMPT
export const CORRECTION_PROMPT_VERSION = 'correction-2026-09-28'       // PhotoRecognizeDialog, правка одним словом
export const BARCODE_PHOTO_PROMPT_VERSION = 'barcode-photo-2026-09-28' // BarcodeScannerDialog.BARCODE_PROMPT
export const BARCODE_LABEL_PROMPT_VERSION = 'barcode-label-2026-09-28' // LabelReviewDialog.BARCODE_PROMPT
